import { jsx as _jsx } from "react/jsx-runtime";
import { useTrackClickedSaveCustomField } from "@air/analytics";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { stopEscKeyPropagationOnAssetDetailsModal } from "~/components/AssetModal/shared/hooks/useAssetModalEscKeyHandler";
import { CustomFieldModal } from "~/components/CustomFields/CustomFieldModal/CustomFieldModal";
import { currentViewTypeNameSelector } from "~/store/configViews/selectors";
import { useDeleteWorkspaceCustomField } from "~/swr-hooks/customFields/useDeleteWorkspaceCustomField";
import { useEditWorkspaceCustomField } from "~/swr-hooks/customFields/useEditWorkspaceCustomField";
import { useGetCustomFieldColors } from "~/swr-hooks/customFields/useGetCustomFieldColors";
import { useGetCustomFieldTypes } from "~/swr-hooks/customFields/useGetFieldTypes";
import { useGetPrivateCustomFieldOptions } from "~/swr-hooks/customFields/useGetPrivateCustomFieldOptions";
import { selectableCustomFields } from "~/swr-hooks/customFields/utils";
import { useGetPrivateConfigViewOptions } from "~/swr-hooks/gallery/viewFields/useGetPrivateConfigViewsOptions";
export const CustomFieldsEditModal = (param)=>{
    let { onClose, field, trackingLocation, onSaveChanges, onDelete } = param;
    const { data: colors } = useGetCustomFieldColors();
    const { data: fieldTypes } = useGetCustomFieldTypes();
    const needsCfOptions = selectableCustomFields.includes(field.type.title);
    const { data: cfOptions } = useGetPrivateCustomFieldOptions({
        customFieldId: field.id,
        enabled: !!needsCfOptions
    });
    const viewType = useSelector(currentViewTypeNameSelector);
    const { refetch: refetchConfigViews } = useGetPrivateConfigViewOptions({
        viewType
    });
    const { deleteCustomField } = useDeleteWorkspaceCustomField();
    const { trackClickedSaveCustomField } = useTrackClickedSaveCustomField();
    const { editCustomField } = useEditWorkspaceCustomField();
    useEffect(()=>{
        stopEscKeyPropagationOnAssetDetailsModal(true);
        return ()=>{
            stopEscKeyPropagationOnAssetDetailsModal(false);
        };
    }, []);
    var _field_description;
    return /*#__PURE__*/ _jsx(CustomFieldModal, {
        modalType: "edit",
        fieldTypes: fieldTypes === null || fieldTypes === void 0 ? void 0 : fieldTypes.data,
        isLoading: editCustomField.isPending || deleteCustomField.isPending,
        handleDelete: ()=>deleteCustomField.mutateAsync({
                customFieldId: field.id,
                trackingLocation
            }, {
                onSuccess: ()=>{
                    onDelete === null || onDelete === void 0 ? void 0 : onDelete();
                    onClose();
                }
            }),
        handleSubmit: async (formValues)=>{
            editCustomField.mutate({
                formValues,
                id: field.id,
                colors: colors === null || colors === void 0 ? void 0 : colors.data
            }, {
                onSuccess: ()=>{
                    trackClickedSaveCustomField({
                        location: trackingLocation
                    });
                    refetchConfigViews();
                    onSaveChanges === null || onSaveChanges === void 0 ? void 0 : onSaveChanges();
                    onClose();
                }
            });
        },
        initialFormValues: {
            description: (_field_description = field.description) !== null && _field_description !== void 0 ? _field_description : "",
            fieldTypeId: field.type.id,
            id: field.id,
            name: field.name,
            values: (cfOptions === null || cfOptions === void 0 ? void 0 : cfOptions.data) || []
        },
        onClose: onClose,
        colors: (colors === null || colors === void 0 ? void 0 : colors.data) || [],
        isDataLoading: needsCfOptions && !cfOptions
    });
};
